<template>
    <i18n :path="effectiveQuery ? 'youSeeNOfMHits' : 'youSeeNOfMHitsFilterOnly'" tag="span">
        <template #ITEMS_PER_PAGE>
            {{ Math.min(first + count, total) }}
        </template>
        <template #TOTAL_RESULTS>
            {{ total }}
        </template>
        <template #QUERY>
            <span class="font-weight-bold font-italic">"{{ effectiveQuery }}"</span>
        </template>
    </i18n>
</template>

<script>
export default {
    name: 'QueryInfo',
    props: {
        first: {
            type: Number,
            required: true,
        },
        count: {
            type: Number,
            required: true,
        },
        total: {
            type: Number,
            required: true,
        },
        effectiveQuery: {
            type: String,
            required: true,
        },
    },
};
</script>

<style scoped></style>
